import type {Ref} from 'vue';
import {ref} from 'vue';
import type {ProblemDetail} from '~/lib/types/fetchErrors';

/* eslint-disable @typescript-eslint/no-explicit-any */

export type FetchedEntity<TData, TError> =
	| { state: 'loading', data: null, error: null }
	| { state: 'success', data: TData, error: null }
	| { state: 'error', data: null, error: TError }

export const useFetchedEntity = <TData, TError = ProblemDetail>(fetch: () => Promise<{
	data?: TData,
	error?: TError
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
}>): { result: Ref<FetchedEntity<TData, TError>>, refresh: Function } => {
	const result = ref<FetchedEntity<TData, TError>>({
		state: 'loading',
		data: null,
		error: null
	});

	const refresh = () => {
		result.value.state = 'loading';
		result.value.data = null;
		result.value.error = null;

		fetch().then(({data, error}) => {
			if (error || !data) {
				result.value.state = 'error';
				result.value.error = error as any;
			} else {
				result.value.state = 'success';
				result.value.data = data as any;
			}
		});
	};

	refresh();

	// Unfortunately, we have to cast the result to any here, because Vue's UnwrapRef
	// doesn't work well when the type is a generic type.
	return {result, refresh} as any;
};
